// extracted by mini-css-extract-plugin
export default {"rolePicker":"costs-page_rolePicker__xsuNU","inactiveValue":"costs-page_inactiveValue__YSBI6"};